// import React, { useCallback, useEffect, useState } from "react";
// import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import * as XLSX from 'xlsx';
// import {
//   Row, Col, Card, Table, Button, Input, AutoComplete,
//   notification, Modal, Select, Avatar, Typography, TableColumnsType,
//   Checkbox, DatePicker, Drawer, Form, InputNumber, Space, Tooltip, Upload
// } from "antd";


// import axios from "axios";
// import { baseUrl } from "../../config"; 
// import {
//   DeleteOutlined, FileExcelOutlined, CalendarOutlined, SendOutlined,
//   FilterOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined,
//   EyeOutlined, UserOutlined, PlusOutlined, UploadOutlined
// } from "@ant-design/icons";
// import userDummy from "../../assets/images/dummy-user.png";
// import { getPermissions, hasPermission } from '../../components/permissions';
// import '../../assets/styles/custom_style.css';
// import moment from 'moment';

// import AddUserDetailsModel from './Form';
 
// import InquiryForm from './Form';      

// const { confirm } = Modal;
// const { Search } = Input; 
// const { Option } = Select;
// const { Title } = Typography;
// const { Item } = Form;
// const { TextArea } = Input;
   

// // Table columns definition
// const columns = [

//   {
//     title: "#",
//     dataIndex: "key",
//     key: "key",
//     fixed: 'left',
//     width: 50,
//   },
//   {
//     title: "Assigned By",
//     dataIndex: "assigned_by",
//     key: "assigned_by",
//     fixed: 'left',
//     width: 150,
//   },

//   {
//     title: "Assigned Date",
//     dataIndex: "assigned_date",
//     key: "assigned_date",
//   },
//   {
//     title: "Description",
//     dataIndex: "description",
//     key: "description",
//   },
//   {
//     title: 'Assigned To',
//     dataIndex: 'assigned_to_name',
//     key: 'assigned_to_name',
//   },

//   {
//     title: "Remark By Assignee",
//     dataIndex: "remark_by_assignee",
//     key: "remark_by_assignee"
//   },
//   {
//     title: "Date Completion",
//     dataIndex: "date_completion",
//     key: "date_completion",
//   },
//   {
//     title: "Remark By Staff",
//     dataIndex: "remark_by_staff",
//     key: "remark_by_staff",
//   },
  
//   {
//     title: "CreatedAt",
//     dataIndex: "createdAt",
//     key: "createdAt",
//   },

//   {
//     title: "Status",
//     dataIndex: "status",
//     key: "status",
//     fixed: 'right',
//   },
//   {
//     title: "Action",
//     key: "action",
//     dataIndex: "action",
//     fixed: 'right',
//   }
// ];



// function Inquiry() {

//   const history = useHistory();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const currentPageQuery = parseInt(queryParams.get('page')) || 1;
//   const limitQuery = parseInt(queryParams.get('limit')) || 20;

//   const [userList, setUserList] = useState([]);
//   const [pagination, setPagination] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(limitQuery);
//   const [sortField, setSortField] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [search, setSearch] = useState('');
//   const [staffList, setStaffList] = useState([]);
//   const [purnimaSettingRecord, setPurnimaSettingRecord] = useState();
//   const [filters, setFilters] = useState({
//     assigned_by: queryParams.get('assigned_by') || '',
//     assigned_date: queryParams.get('assigned_date') || '',
//     description: queryParams.get('description') || '',
//     inquiry_regards: queryParams.get('inquiry_regards') || '',
//     description: queryParams.get('description') || '',
//     assigned_to: queryParams.get('assigned_to') || '',
//     remark_by_assignee: queryParams.get('remark_by_assignee') || '',
//     date_completion: queryParams.get('date_completion') || '', 
//     remark_by_staff: queryParams.get('remark_by_staff') || '', 
//     status: queryParams.get('status') || '',
//     createdAt: queryParams.get('createdAt') || '',
//   });
 
//   const [showUserFilter, setShowUserFilter] = useState(true);
//   const [showPurnimaMessageForm, setShowPurnimaMessageForm] = useState(false);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);
//   const [currentImage, setCurrentImage] = useState("");
//   const { id } = useParams(); // Extract id from URL 
//   const [form] = Form.useForm();
//   const [isUpdateMode, setIsUpdateMode] = useState(false);
//   const [txnDate, setTxnDate] = useState();
//   const [meetingDate, setMeetingDate] = useState();
//   const [addForm, setAddForm] = useState(false);
//   const [sendMessage, setSendMessage] = useState(false);
//   const [AddUserDetailsFormModel, setAddUserDetailsModel] = useState(false);
//   const [userId, setuserId] = useState();


//   useEffect(() => {
//     getStaffList();
//     const { state } = history.location;  
//     const restoredPage = state?.page || currentPage; // Restore page from state or use current page
//     const restoredLimit = state?.limit || limit; // Restore limit from state or use current limit

//     // Call getUserList with restored page and limit
//     getUserList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
//   }, [history.location]);


//   const AddUserDetailsClose = () => {
//     setAddUserDetailsModel(false)
//     const { state } = history.location; // Get the state from history
//     const restoredPage = state?.page || currentPage; // Restore page from state or use current page
//     const restoredLimit = state?.limit || limit; // Restore limit from state or use current limit

//     // Call getUserList with restored page and limit
//     getUserList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
//   }



//   async function getUserList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
//     try {
//       setCurrentPage(page);
//       setLimit(limit);
//       const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
//       const searchParam = search ? `&search=${search}` : '';
//       const filterParams = Object.keys(filters)
//         .map(key => `${key}=${filters[key]}`)
//         .join('&');
//       const response = await axios.get(`${baseUrl}/work_managment/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         }
//       });
//       if (response.data.status) {
//         setUserList(response.data.result);
//         // setUserList([])
//         setPagination({
//           current: page,
//           pageSize: limit,
//           total: response.data.totalCount
//         });
//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRight'
//         });
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   async function handleDelete(id) {
//     try {
//       const response = await axios.delete(`${baseUrl}/work_managment/delete/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         },
//       });
//       if (response.status === 200) {
//         getUserList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
//         notification.success({
//           message: 'Success',
//           description: 'Record deleted successfully!',
//           placement: 'topRight'
//         });
//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRight'
//         });
//       }    
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   const showDeleteConfirm = (id) => {
//     confirm({
//       title: 'Are you sure you want to delete this item?',
//       icon: <ExclamationCircleOutlined />,
//       content: 'This action cannot be undone.',
//       okText: 'Yes',
//       okType: 'danger',
//       cancelText: 'No',
//       onOk() {
//         handleDelete(id);
//       },
//     });
//   };

//   const handleTableChange = (pagination, filters, sorter) => {
//     const { current, pageSize } = pagination;
//     const { field, order } = sorter;
//     const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
//     setSortField(field);
//     setSortOrder(formattedOrder);
//     setFilters(filters);

//     // Update both current page and limit in the history
//     history.push(`?page=${current}&limit=${pageSize}`);

//     // Fetch the updated payment list
//     getUserList(current, pageSize, field, formattedOrder, search, filters);
//   };


//   const handleLimitChange = value => {
//     setLimit(value);

//     // Update URL with the new limit and reset page to 1
//     const updatedQueryParams = new URLSearchParams(location.search);
//     updatedQueryParams.set('limit', value);
//     updatedQueryParams.set('page', 1); // Reset to first page whenever limit changes

//     // Push new URL with updated query params
//     history.push(`?${updatedQueryParams.toString()}`);

//     // Call the API to fetch data with updated limit
//     getUserList(1, value);  // Assuming your API call accepts page and limit
//   };


//   const handleFilterChange = (field, value) => {
//     const newFilters = {
//       ...filters,
//       [field]: value
//     };
//     setFilters(newFilters);

//     // Optionally, update the URL without triggering a search immediately
//     const updatedQueryParams = new URLSearchParams(location.search);
//     Object.keys(newFilters).forEach(key => {
//       if (newFilters[key]) {
//         updatedQueryParams.set(key, newFilters[key]);
//       } else {
//         updatedQueryParams.delete(key); // Remove empty filters from the URL
//       }
//     });
//     history.push(`?${updatedQueryParams.toString()}`);
//   };


//   const handleUserFilterCheckboxChange = (e) => {
//     setShowUserFilter(e.target.checked);

//   };


//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   const handleCancelImportList = () => {
//     setIsModalVisibleImportList(false);
//   };

//   const handleOnSuccess = () => {
//     setIsModalVisibleImportList(false);
//     getUserList();
//   };



//   const toggleFormVisibility = () => {
//     setAddForm(prevState => !prevState); // Toggle between true and false
//   };


//   const AddUserDetails = async (userId) => {
//     console.log('uid', userId)
//     setuserId(userId);
//     setAddUserDetailsModel(true)

//   }

//   async function getStaffList() {
//     try {
//       const response = await axios.get(`${baseUrl}/staff/list`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         }
//       });
//       if (response.data.status) {
//         setStaffList(response.data.result);
//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRighft'
//         });
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   const onRefresh = async () => {
//     setAddForm(false);
//     getUserList();
//   }

//   return (
//     <div className="tabled">
//       <Row gutter={[24, 0]}>

//         {addForm && (
//           <Col xs="24" xl={24}>
//             <InquiryForm userId={null} onRefreshData={onRefresh} />
//           </Col>

//         )}
//         <Col xs="24" xl={24}>
//           <Card
//             bordered={false}
//             className="criclebox tablespace mb-24"
//             title="Work Managment List"
//             extra={
//               <div style={{ display: 'flex', gap: '10px' }}>
//                 {hasPermission('/work_managment', 'createPermission') && (
//                   <button onClick={toggleFormVisibility} className="custom-btn">Add Work Managment Form</button>
//                 )}
//               </div>
//             }

//           >
//             <div className="table-responsive">
//               <Table
//                 columns={columns}
//                 pagination={false}
//                 scroll={{ x: 'max-content' }}
//                 bordered
//                 title={() => (
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Row gutter={[16, 16]}>
//                       <Col xs={24}>
//                         <FilterOutlined /> <Checkbox onChange={handleUserFilterCheckboxChange}><Title style={{ fontSize: 13 }} level={5}>Form Filter</Title></Checkbox>
//                       </Col>
//                       {showUserFilter && (
//                         <>
//                           <Col span={4}> <Input placeholder="Assigned By" value={filters.assigned_by} onChange={e => handleFilterChange('assigned_by', e.target.value)} /></Col>
//                           <Col span={4}>
//                             <DatePicker className="filter_dob CustomInputSet"
//                               format="DD-MM-YYYY" value={filters.assigned_date ? moment(filters.assigned_date, 'DD-MM-YYYY') : null}
//                               onChange={(date, dateString) => handleFilterChange('assigned_date', dateString)} placeholder="Assigned Date"
//                             />
//                           </Col>

//                           <Col span={4}><Input placeholder="Description" value={filters.description} onChange={e => handleFilterChange('description', e.target.value)} /></Col>

//                           <Col span={4}>
//                               <Select style={{ width: '100%' }} placeholder="Assigned To" value={filters.assigned_to} onChange={value => handleFilterChange('assigned_to', value)}>

//                                 <Option value="">Assigned To</Option>
//                                 {staffList && staffList.map((item, i) => (
//                                   <Option value={item.id}>{item.firstName} {item.lastName}</Option>
//                                 ))}
//                               </Select> 
//                               </Col>

//                           <Col span={4}> <Input placeholder="Remark By Assignee" value={filters.remark_by_assignee} onChange={e => handleFilterChange('remark_by_assignee', e.target.value)} /></Col>
                         

//                           <Col span={4}> 
//                             <Select style={{ width: '100%' }} placeholder="Assigned By" value={filters.attend_by} onChange={value => handleFilterChange('attend_by', value)}>

//                               <Option value=""> Assigned By</Option>
//                               {staffList && staffList.map((item, i) => (
//                                 <Option value={item.id}>{item.firstName} {item.lastName}</Option>
//                               ))}
//                             </Select>
//                             </Col>

//                             <Col span={4}>
//                               <DatePicker className="filter_dob CustomInputSet"
//                                 format="DD-MM-YYYY" value={filters.date_completion ? moment(filters.date_completion, 'DD-MM-YYYY') : null}
//                                 onChange={(date, dateString) => handleFilterChange('date_completion', dateString)} placeholder="Date Completion"
//                               />
//                             </Col>


                          

//                              <Col span={4}>
//                               <Input placeholder="Remark By Staff" value={filters.remark_by_staff} onChange={e => handleFilterChange('remark_by_staff', e.target.value)}
//                               />
//                             </Col>

                           


//                             <Col span={4}>

//                             <Select style={{ width: '100%' }} placeholder="Status" value={filters.status} onChange={value => handleFilterChange('status', value)}>
//                               <Option value="">Select Status</Option>
//                               <Option value="Pending">Pending</Option>
//                               <Option value="InProcess">InProcess</Option>
//                               <Option value="Completed">Completed</Option>
                             
//                             </Select>

                             
//                             </Col>

//                             <Col span={4}>
//                               <DatePicker className="filter_dob CustomInputSet"
//                                 format="DD-MM-YYYY" value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
//                                 onChange={(date, dateString) => handleFilterChange('createdAt', dateString)} placeholder="Created Date"
//                               />
//                             </Col>


//                           </>
//                       )}

//                           <Col xs={24}>
//                             <span style={{ marginRight: 10 }}>Records per page:</span>
//                             <Select defaultValue={20} onChange={handleLimitChange}>
//                               <Option value={20}>20</Option>
//                               <Option value={40}>40</Option>
//                               <Option value={60}>60</Option>
//                               <Option value={80}>80</Option>
//                               <Option value={100}>100</Option>
//                             </Select>
//                           </Col>
//                         </Row>
//                   </div>
//                 )}
//                 dataSource={userList.map((user, index) => {
//                    return {
//                     key: (limit * (currentPage - 1)) + index + 1,
//                     assigned_by: (
//                       <div className="author-info">
//                         <Title level={5} >
//                           {user.assigned_by}
//                         </Title>

//                       </div>
//                     ),
//                     assigned_date: (
//                       <>
//                         <div className="author-info">
//                         <Title level={5}>{user.assigned_date && user.assigned_date != "0000-00-00" ? moment(user.assigned_date).format('DD MMMM YYYY') : '-'}</Title>
//                         </div>
//                       </>
//                     ),
//                     description: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}> {user.description}</Title>
//                         </div>
//                       </>
//                     ),
                     
//                     assigned_to_name: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.assigned_to_name}  </Title>
//                         </div>
//                       </>
//                     ),


//                     remark_by_assignee: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.remark_by_assignee}  </Title>
//                         </div>
//                       </>
//                     ),

//                     date_completion: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.date_completion && user.date_completion != "0000-00-00" ? moment(user.date_completion).format('DD MMMM YYYY') : '-'}</Title>

//                         </div>
//                       </>
//                     ),
//                     remark_by_staff: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.remark_by_staff}  </Title>
//                         </div>
//                       </>
//                     ),
                    
//                     status: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.status}  </Title>
//                         </div>
//                       </>
//                     ),
                    
                 

//                     createdAt: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.createdAt && user.createdAt != "0000-00-00" ? moment(user.createdAt).format('DD MMMM YYYY') : '-'}</Title>

//                         </div>
//                       </>
//                     ),
//                     action: (
//                       <div className="button-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

//                        {hasPermission('/work_managment', 'editPermission') && (
//                         <Button onClick={() => AddUserDetails(user.id)} className="update-btn">
//                           <EditOutlined />
//                         </Button>
//                         )}

//                         {hasPermission('/work_managment', 'deletePermission') && (

//                         <Button onClick={() => showDeleteConfirm(user.id)} className="delete-btn">
//                           <DeleteOutlined />
//                         </Button>
//                          )}  
//                       </div>
//                     )
//                   };
//                 })}
//                 pagination={{
//                   ...pagination,
//                   showTotal: total => `Total ${total} records`,
//                   style: { marginRight: 20 }
//                 }}
//                 onChange={handleTableChange}
//                 className="ant-border-space"
//               />
//             </div>
//           </Card>
//         </Col>
//       </Row>

//       <Modal
//         open={isModalVisible}
//         footer={null}
//         onCancel={handleCancel} 
//       >
//         <img
//           src={currentImage}
//           alt="Profile"
//           style={{ width: '100%' }}
//         />
//       </Modal>

        

//       <Drawer
//         title="Work Managment Details"
//         width={1000}
//         onClose={AddUserDetailsClose}
//         open={AddUserDetailsFormModel}
//         styles={{
//           body: {
//             paddingBottom: 80,
//           },
//         }}
//         maskClosable={false}
//       >
//         <AddUserDetailsModel userId={userId} />
//       </Drawer>
//     </div>
//   );
// }


// export default Inquiry;



import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input, AutoComplete,
  notification, Modal, Select, Avatar, Typography, TableColumnsType,
  Checkbox, DatePicker, Drawer, Form, InputNumber, Space, Tooltip, Tag, Spin,
  Progress, Badge
} from "antd";

import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined, CalendarOutlined, SendOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined,
  EyeOutlined, UserOutlined, PlusOutlined, ReloadOutlined, CloseOutlined,
  ProjectOutlined, ClockCircleOutlined, CheckCircleOutlined, SyncOutlined,
  FileTextOutlined, TeamOutlined
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import WorkManagementForm from './Form';

const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;
const { Item } = Form;
const { TextArea } = Input;

function WorkManagement() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || 20;

  const [workList, setWorkList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);

  const [filters, setFilters] = useState({
    assigned_by: queryParams.get('assigned_by') || '',
    assigned_date: queryParams.get('assigned_date') || '',
    description: queryParams.get('description') || '',
    assigned_to: queryParams.get('assigned_to') || '',
    remark_by_assignee: queryParams.get('remark_by_assignee') || '',
    date_completion: queryParams.get('date_completion') || '',
    remark_by_staff: queryParams.get('remark_by_staff') || '',
    status: queryParams.get('status') || '',
    createdAt: queryParams.get('createdAt') || '',
  });

  // Drawer states
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentWorkId, setCurrentWorkId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Filter states
  const [showWorkFilter, setShowWorkFilter] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  // Enhanced table columns with better styling
  const columns = [
    {
      title: <Text strong style={{ color: '#1890ff' }}>#</Text>,
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Assigned By</Text>,
      dataIndex: "assigned_by",
      key: "assigned_by",
      fixed: 'left',
      width: 150,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Assigned Date</Text>,
      dataIndex: "assigned_date",
      key: "assigned_date",
      width: 130,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Description</Text>,
      dataIndex: "description",
      key: "description",
      width: 200,
      ellipsis: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Assigned To</Text>,
      dataIndex: 'assigned_to_name',
      key: 'assigned_to_name',
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Assignee Remark</Text>,
      dataIndex: "remark_by_assignee",
      key: "remark_by_assignee",
      width: 150,
      ellipsis: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Completion Date</Text>,
      dataIndex: "date_completion",
      key: "date_completion",
      width: 130,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Staff Remark</Text>,
      dataIndex: "remark_by_staff",
      key: "remark_by_staff",
      width: 150,
      ellipsis: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Status</Text>,
      dataIndex: "status",
      key: "status",
      width: 120,
      fixed: 'right',
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Created Date</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 130,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#1890ff' }}>Actions</Text>,
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 120,
      align: 'center',
    }
  ];

  useEffect(() => {
    getStaffList();
    const { state } = history.location;
    const restoredPage = state?.page || currentPage;
    const restoredLimit = state?.limit || limit;
    getWorkList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
  }, [history.location]);

  // Drawer functions
  const showDrawer = (workId = null) => {
    setCurrentWorkId(workId);
    setIsUpdateMode(!!workId);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setCurrentWorkId(null);
    setIsUpdateMode(false);
  };

  const onRefresh = () => {
    closeDrawer();
    getWorkList(currentPage, limit, sortField, sortOrder, search, filters);
  };

  async function getWorkList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setLoading(true);
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/work_managment/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setWorkList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: 'Failed to fetch work management data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  }

  async function getStaffList() {
    try {
      const response = await axios.get(`${baseUrl}/staff/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setStaffList(response.data.result);
      }
    } catch (error) {
      console.error("Staff list API error:", error);
    }
  }

  async function handleDelete(id) {
    try {
      const response = await axios.delete(`${baseUrl}/work_managment/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getWorkList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Work item deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: 'Failed to delete work item',
        placement: 'topRight'
      });
    }
  }

  const showDeleteConfirm = (id, description) => {
    confirm({
      title: 'Delete Work Item',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Are you sure you want to delete this work item?</p>
          {description && (
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              padding: '8px 12px', 
              borderRadius: '6px',
              marginTop: '8px'
            }}>
              <Text strong style={{ color: '#cf1322' }}>Work to be deleted:</Text>
              <br />
              <Text>{description.length > 50 ? `${description.substring(0, 50)}...` : description}</Text>
            </div>
          )}
          <p style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '8px' }}>
            ⚠️ This action cannot be undone.
          </p>
        </div>
      ),
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
        style: { borderRadius: '6px' }
      },
      cancelButtonProps: {
        style: { borderRadius: '6px' }
      },
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    history.push(`?page=${current}&limit=${pageSize}`);
    getWorkList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set('limit', value);
    updatedQueryParams.set('page', 1);
    history.push(`?${updatedQueryParams.toString()}`);
    getWorkList(1, value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);
  };

  const handleSearch = () => {
    getWorkList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      assigned_by: '',
      assigned_date: '',
      description: '',
      assigned_to: '',
      remark_by_assignee: '',
      date_completion: '',
      remark_by_staff: '',
      status: '',
      createdAt: '',
    };
    setFilters(resetFilters);
    setSearch('');
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach(key => {
      updatedQueryParams.delete(key);
    });
    history.push(`?${updatedQueryParams.toString()}`);
    getWorkList(1, limit, sortField, sortOrder, '', resetFilters);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return 'orange';
      case 'InProcess':
        return 'blue';
      case 'Completed':
        return 'green';
      default:
        return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Pending':
        return <ClockCircleOutlined />;
      case 'InProcess':
        return <SyncOutlined spin />;
      case 'Completed':
        return <CheckCircleOutlined />;
      default:
        return <ClockCircleOutlined />;
    }
  };

  const exportToExcel = async () => {
    try {
      setLoading(true);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/work_managment/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const formattedData = response.data.result.map((work, index) => ({
          "Sr.No": index + 1,
          "Assigned By": work.assigned_by || '-',
          "Assigned Date": work.assigned_date ? moment(work.assigned_date).format('DD-MM-YYYY') : '-',
          "Description": work.description || '-',
          "Assigned To": work.assigned_to_name || '-',
          "Assignee Remark": work.remark_by_assignee || '-',
          "Completion Date": work.date_completion ? moment(work.date_completion).format('DD-MM-YYYY') : '-',
          "Staff Remark": work.remark_by_staff || '-',
          "Status": work.status || '-',
          "Created Date": work.createdAt ? moment(work.createdAt).format('DD-MM-YYYY') : '-',
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Work-Management-List");
        XLSX.writeFile(workbook, "Work-Management-List.xlsx");
        
        notification.success({
          message: 'Success',
          description: 'Work management list exported successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to export data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <ProjectOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                  Work Management System
                </Title>
              </div>
            }
            extra={
              <Space size="middle">
                {hasPermission('/work_managment', 'createPermission') && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => showDrawer()}
                    style={{
                      background: '#7a0000',
                      border: 'none',
                      borderRadius: '6px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    Add Work Item
                  </Button>
                )}
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={exportToExcel}
                  loading={loading}
                  style={{ borderRadius: '6px' }}
                >
                  Export Excel
                </Button>
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowWorkFilter(!showWorkFilter)}
                          style={{
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {showWorkFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                    </Row>

                    {/* Filters */}
                    {showWorkFilter && (
                      <div style={{
                        marginTop: '16px',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Title level={5} style={{ marginBottom: '16px', color: '#1890ff' }}>
                          🔍 Filter Work Items
                        </Title>
                        <Row gutter={[12, 12]}>
                          <Col span={6}>
                            <Input
                              placeholder="Assigned By"
                              value={filters.assigned_by}
                              onChange={e => handleFilterChange('assigned_by', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              format="DD-MM-YYYY"
                              value={filters.assigned_date ? moment(filters.assigned_date, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('assigned_date', dateString)}
                              placeholder="Assigned Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Description"
                              value={filters.description}
                              onChange={e => handleFilterChange('description', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              style={{ width: '100%' }}
                              placeholder="Assigned To"
                              value={filters.assigned_to}
                              onChange={value => handleFilterChange('assigned_to', value)}
                              allowClear
                            >
                              {staffList.map((staff) => (
                                <Option key={staff.id} value={staff.id}>
                                  {staff.firstName} {staff.lastName}
                                </Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Assignee Remark"
                              value={filters.remark_by_assignee}
                              onChange={e => handleFilterChange('remark_by_assignee', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              format="DD-MM-YYYY"
                              value={filters.date_completion ? moment(filters.date_completion, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('date_completion', dateString)}
                              placeholder="Completion Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Staff Remark"
                              value={filters.remark_by_staff}
                              onChange={e => handleFilterChange('remark_by_staff', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              style={{ width: '100%' }}
                              placeholder="Status"
                              value={filters.status}
                              onChange={value => handleFilterChange('status', value)}
                              allowClear
                            >
                              <Option value="Pending">Pending</Option>
                              <Option value="InProcess">In Process</Option>
                              <Option value="Completed">Completed</Option>
                            </Select>
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              format="DD-MM-YYYY"
                              value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('createdAt', dateString)}
                              placeholder="Created Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>

                          <Col span={24}>
                            <Space>
                              <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                style={{ borderRadius: '6px' }}
                              >
                                Search
                              </Button>
                              <Button
                                icon={<ReloadOutlined />}
                                onClick={handleResetFilters}
                                style={{ borderRadius: '6px' }}
                              >
                                Reset All Filters
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <Row style={{ marginTop: '16px' }}>
                      <Col>
                        <Space align="center">
                          <Text strong>Records per page:</Text>
                          <Select
                            value={limit}
                            onChange={handleLimitChange}
                            style={{ width: 80, borderRadius: '6px' }}
                          >
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                          </Select>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={workList.map((work, index) => {
                  return {
                    key: (limit * (currentPage - 1)) + index + 1,
                    assigned_by: (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <UserOutlined style={{ color: '#1890ff' }} />
                        <Text strong style={{ color: '#262626' }}>{work.assigned_by || '-'}</Text>
                      </div>
                    ),
                    assigned_date: (
                      <Text>
                        {work.assigned_date && work.assigned_date !== "0000-00-00" 
                          ? moment(work.assigned_date).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    description: (
                      <Tooltip title={work.description} placement="topLeft">
                        <Text style={{ color: '#595959' }}>
                          {work.description ? (work.description.length > 50 ? `${work.description.substring(0, 50)}...` : work.description) : '-'}
                        </Text>
                      </Tooltip>
                    ),
                    assigned_to_name: (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <TeamOutlined style={{ color: '#52c41a' }} />
                        <Text style={{ color: '#595959' }}>{work.assigned_to_name || '-'}</Text>
                      </div>
                    ),
                    remark_by_assignee: (
                      <Tooltip title={work.remark_by_assignee} placement="topLeft">
                        <Text style={{ color: '#595959' }}>
                          {work.remark_by_assignee ? (work.remark_by_assignee.length > 30 ? `${work.remark_by_assignee.substring(0, 30)}...` : work.remark_by_assignee) : '-'}
                        </Text>
                      </Tooltip>
                    ),
                    date_completion: (
                      <Text>
                        {work.date_completion && work.date_completion !== "0000-00-00" 
                          ? moment(work.date_completion).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    remark_by_staff: (
                      <Tooltip title={work.remark_by_staff} placement="topLeft">
                        <Text style={{ color: '#595959' }}>
                          {work.remark_by_staff ? (work.remark_by_staff.length > 30 ? `${work.remark_by_staff.substring(0, 30)}...` : work.remark_by_staff) : '-'}
                        </Text>
                      </Tooltip>
                    ),
                    status: (
                      <Badge 
                        status={getStatusColor(work.status)} 
                        text={
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {getStatusIcon(work.status)}
                            <Text style={{ fontSize: '12px', fontWeight: '500' }}>
                              {work.status || 'Pending'}
                            </Text>
                          </div>
                        }
                      />
                    ),
                    createdAt: (
                      <Text>
                        {work.createdAt && work.createdAt !== "0000-00-00" 
                          ? moment(work.createdAt).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    action: (
                      <Space size="small">
                        {hasPermission('/work_managment', 'editPermission') && (
                          <Tooltip title="Edit Work Item">
                            <Button
                              type="primary"
                              size="small"
                              icon={<EditOutlined />}
                              onClick={() => showDrawer(work.id)}
                              style={{ borderRadius: '4px' }}
                            />
                          </Tooltip>
                        )}
                        {hasPermission('/work_managment', 'deletePermission') && (
                          <Tooltip title="Delete Work Item">
                            <Button
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() => showDeleteConfirm(work.id, work.description)}
                              style={{ 
                                borderRadius: '4px',
                                background: '#fff1f0',
                                borderColor: '#ffccc7',
                                color: '#cf1322'
                              }}
                            />
                          </Tooltip>
                        )}
                      </Space>
                    )
                  };
                })}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                  showSizeChanger: false,
                  style: { marginTop: '16px' }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Enhanced Drawer for Add/Edit */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: '#7a0000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isUpdateMode ? <EditOutlined style={{ color: 'white', fontSize: '18px' }} /> : <PlusOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                {isUpdateMode ? 'Update Work Item' : 'Add New Work Item'}
              </Title>
              <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
                {isUpdateMode ? 'Modify work item details' : 'Create a new work assignment'}
              </Text>
            </div>
          </div>
        }
        width={window.innerWidth > 1200 ? 1200 : window.innerWidth > 768 ? 1000 : '95%'}
        open={drawerVisible}
        onClose={closeDrawer}
        bodyStyle={{
          padding: 0,
          background: '#f8f9fa'
        }}
        headerStyle={{
          background: '#7a0000',
          border: 'none'
        }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={closeDrawer}
            style={{ color: 'white' }}
          />
        }
        destroyOnClose
      >
        <div style={{ height: '100%', padding: '24px' }}>
          <WorkManagementForm 
            userId={currentWorkId} 
            onRefreshData={onRefresh}
          />
        </div>
      </Drawer>

      {/* Image Modal */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        centered
      >
        <img
          src={currentImage}
          alt="Work Document"
          style={{ width: '100%', borderRadius: '8px' }}
        />
      </Modal>
    </div>
  );
}

export default WorkManagement;
